import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  InlineFilter,
  InlineFilterProps,
} from '../../../features/Filters/InlineFilter/InlineFilter';
import {InlineFilterError} from '../../../features/Filters/InlineFilter/InlineFilterError';
import {InlineFilterLoading} from '../../../features/Filters/InlineFilter/InlineFilterLoading';
import {useStoryFilters} from '../utils/useStoryFilters';

export const StoryInlineFilter: React.FC<
  PriorityConfig & InlineFilterProps
> = props => (
  <DataFetcher
    request={useStoryFilters()}
    Error={InlineFilterError}
    Loading={InlineFilterLoading}
    View={InlineFilter}
    viewProps={props}
    renderingPriority={props.renderingPriority}
  />
);
